<dialog #dialog class="w-60">
  <div class="modal-header">
    <span>UPP</span>
    <button
      type="button"
      aria-label="zamknij"
      class="btn btn-secondary icon-btn dialog-close"
      autofocus
      (click)="dialog.close()">
      <i aria-hidden="true" class="fa fa-times"></i>
    </button>
  </div>
  <div class="modal-content">
    <div class="doc-preview">
      <iframe
        referrerpolicy="strict-origin-when-cross-origin"
        [src]="(env.apiBasePath + '/application/' + application()?.uuid + '/upp-html') | safeContent: 'resourceUrl'">
      </iframe>
    </div>
  </div>
</dialog>
